import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'qr-overlay-topbar',
  templateUrl: './overlay-topbar.component.html',
  styleUrls: ['./overlay-topbar.component.scss'],
})
export class OverlayTopbarComponent {
  @Input() isFullscreen: boolean = false;
  @Input() isCloseButtonVisible?: boolean = true;
  @Output() close: EventEmitter<null> = new EventEmitter();
  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };
}
